import FilterListIcon from '@mui/icons-material/FilterList';
import { useIsMobile } from '@core/hooks/useIsMobile';
import ActionBadge from './ActionBadge';
import ActionButton from './ActionButton';

export interface PageFilterConfig {
  activeCount?: number;
  onOpen: () => void;
}

type PageFilterProps = PageFilterConfig & {
  size?: 'sm' | 'md';
};

const PageFilter: React.FC<PageFilterProps> = ({
  activeCount = 0,
  onOpen,
  size = 'md',
}) => {
  const isMobile = useIsMobile();

  return (
    <ActionBadge badgeContent={activeCount}>
      <ActionButton
        variant="subtle"
        size={size}
        onClick={onOpen}
        icon={<FilterListIcon />}
        aria-label="Open filters"
      >
        {!isMobile && 'Filter'}
      </ActionButton>
    </ActionBadge>
  );
};

export default PageFilter;
